import { ChevronLeft, ChevronRight } from "lucide-react"

import { Button } from "@/components/ui/button"
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog"
import { cn } from "@/lib/utils"

// The larger view (design Lightbox): one image at a time, shown whole, with
// previous and next and the left and right arrow keys. `at` is the open
// image's index, -1 when closed. The Dialog owns Escape and puts focus back on
// the control that opened it. `wide` gives a delivered cover or spread most of
// the screen; the brief's sample picks keep the small view.
export default function ImageLightbox({ title, images, at, onMove, onClose, wide = false }) {
  const image = images[at]
  const last = images.length - 1
  const move = (step) => onMove(Math.min(last, Math.max(0, at + step)))

  return (
    <Dialog open={Boolean(image)} onOpenChange={(open) => !open && onClose()}>
      <DialogContent
        className={cn("gap-3 p-4", wide ? "sm:max-w-[min(94vw,1200px)]" : "sm:max-w-[min(92vw,560px)]")}
        onKeyDown={(event) => {
          if (event.key === "ArrowLeft") move(-1)
          if (event.key === "ArrowRight") move(1)
        }}
      >
        <DialogTitle className="pr-8 text-[14px]">{title}</DialogTitle>
        <DialogDescription className="sr-only">{image?.label ?? ""}</DialogDescription>
        {image && (
          <img
            src={image.url}
            alt={image.label}
            className={cn(
              "mx-auto w-auto max-w-full rounded-[10px] border border-border object-contain",
              wide ? "max-h-[78dvh]" : "max-h-[62dvh]"
            )}
          />
        )}
        <div className="flex items-center justify-between gap-3">
          <Button type="button" variant="outline" size="icon" aria-label="Previous" disabled={at <= 0} onClick={() => move(-1)}>
            <ChevronLeft className="size-4" strokeWidth={2} />
          </Button>
          <span className="text-[13px] font-semibold text-foreground">
            {image?.label ?? ""}
            <span className="ml-[10px] font-medium text-ink-3 tabular-nums">
              {at + 1} / {images.length}
            </span>
          </span>
          <Button type="button" variant="outline" size="icon" aria-label="Next" disabled={at >= last} onClick={() => move(1)}>
            <ChevronRight className="size-4" strokeWidth={2} />
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
